'use strict';

function regexMatcher(reg) {
  reg = RegExp(reg);
  return function(el) {
    return reg.test(el);
  };
}

module.exports = regexMatcher;


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar/common/internal/regexMatcher.js
// module id = 719
// module chunks = 1